module.exports = __webpack_public_path__ + "assets/img/free_27.d4f10c80.png";